<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Ob prvem naročilu vam pripada <b>BREZPLAČNO 3-MESEČNO </b>
          testno obdobje, kar pomeni, da boste prvi račun za Panda produkt plačali šele po 3 mesecih uporabe.
        </p>
      </div>
    </div>
    <div style="clear: both"/>
  </div>
</template>
<script>
export default {
  name: 'InfoKomponentaVarnostnaZascita'
}
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociInternet/InfoKomponentaVarnostnaZascita.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociInternet/InfoKomponentaVarnostnaZascita.vue